export class Brand {

    name: string;
    image: string;

    keywords:string;

    constructor(name,image,keywords='') {

        this.name = name;
        this.image = image;
        this.keywords = keywords;


    }

}


